module.exports = __webpack_public_path__ + "static/media/beep.a0b177a1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/templates/blocks/WorkoutBlocks/sound/beep.mp3
// module id = 341
// module chunks = 0